// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121435/js/" + chunkId + "." + {"44":"5faed4b5","225":"8c6698b6","481":"6ada2b9f","486":"920da241","770":"ce4ab045"}[chunkId] + ".0.7380167090071976.chunk.js";
};